import styled from 'styled-components';

interface StyledAppProps {
  $showLogo: boolean;
}

export const StyledApp = styled.div<StyledAppProps>`
  display: flex;
  flex-direction: column;
  width: 100%;

  header {
    width: 100%;
    display: flex;
    margin: auto;
    align-items: center;
    justify-content: space-around;
    padding: 0 30px;
    box-sizing: border-box;
  }
  main {
    display: flex;
    flex-direction: row;
    justify-content: center;
    z-index: 200;
    height: 100vh;
    padding: ${(props) => (props.$showLogo ? 'unset' : '24px')};

    .video-wrapper-container.minimized {
      margin-top: ${(props) => (props.$showLogo ? 'unset' : '20px')};
    }

    div[data-resize-handle] {
      display: flex;
      align-items: center;
    }

    div[data-resize-handle-active='keyboard'],
    div[data-resize-handle-active='pointer'] {
      background: #999;
      transition: 0.5s;
      > div {
        background: none;
        height: 100% !important;
        border-radius: 5px;
      }
    }
  }

  .sidebar-ctas {
    position: absolute;
    bottom: 50px;
    left: 10px;
    width: 120px;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    justify-content: end;
    row-gap: 10px;

    .cta {
      height: 76px !important;

      .wrapper {
        flex-direction: column !important;
        justify-content: center !important;
        gap: 6px !important;
        padding: 0 !important;
        .title {
          font-size: 12px !important;
          text-align: center;
          line-height: 1em !important;
        }
        .icon {
          height: 36px !important;
          width: 36px !important;
        }
      }
    }
  }
`;

export const StyledPanelResizeHandle = styled.div`
  width: 4px;
  background: #ccc;
  height: 100px;
  border-radius: 5px;
`;
